import React from 'react';
import PropTypes from 'prop-types';

import AppContext from './appContext';
import { ModerationConfig } from '../models';
import { usePermissions } from '../user/permissions';

export default function AppContextProvider({ children }) {
    const [context, _setContext] = React.useState({});
    const permissions = usePermissions();

    const setContext = React.useCallback((ctx = {}) => {
        _setContext(context => {
            return { ...context, ...ctx };
        });
    }, []);

    const removeFromContext = React.useCallback(name => {
        _setContext(context => {
            let newContext = { ...context };
            delete newContext[name];
            return newContext;
        });
    }, []);

    const hasModerationCapacity = Boolean(context?.organization?.id) && Boolean(permissions.hasCapacities(['PyvarCapacity.MODERATION'], context.organization.id));

    ModerationConfig.useApiModel(
        {
            organizationId: context.organization?.id,
            launch: hasModerationCapacity,
            onSuccess: response => setContext({ moderationConfig: response })
        },
        [context.organization?.id, hasModerationCapacity]
    );

    return (
        <AppContext.Provider
            value={{
                context,
                setContext,
                removeFromContext
            }}
        >
            {children}
        </AppContext.Provider>
    );
}

AppContextProvider.propTypes = {
    children: PropTypes.node
};
